import { render, staticRenderFns } from "./contractorsArea.vue?vue&type=template&id=08d3d130&"
import script from "./contractorsArea.vue?vue&type=script&lang=js&"
export * from "./contractorsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports